<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-archive mr-2" /> Retur Kirim Invent
            </h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="No. Faktur">
                        <b-form-input
                            v-model="filter.no_faktur"
                            maxlength="50"
                            placeholder="Cari No. Faktur..."
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Status">
                        <b-form-select
                            v-model="filter.status"
                            :options="optFilterStatus"
                        />
                    </b-form-group>
                </b-col>
                <b-col
                    md="4"
                    class="d-flex align-items-start  justify-content-between"
                >
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                    <b-form-group
                        label="Tambah"
                        class="mb-0 mt-1 mr-3"
                        label-size="sm"
                    >
                        <b-button
                            variant="success"
                            @click="createReturKirimInvent"
                        >
                            <i class="fa fa-plus mr-2" />Retur Kirim Invent Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data Kirim Invent.
                </template>
                <template v-slot:cell(detail)="row">
                    Dibuat:
                    <strong>{{ parseDate(row.item.created_at) }}</strong> <br />

                    <template v-if="row.item.approved_at">
                        Disetujui oleh:
                        <strong>{{ row.item.approved_by }}</strong> -
                        <strong>{{ parseDate(row.item.approved_at) }}</strong>
                    </template>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]">{{
                        getStatusBadge(row.item.status)[1]
                    }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <router-link
                        v-if="row.item.status == 0"
                        :to="'/kirim-inven/retur/draft/' + row.item.id"
                    >
                        <b-button
                            size="sm"
                            variant="success"
                            v-b-tooltip.hover.top
                            title="Lanjut Draft"
                        >
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                    </router-link>
                    <router-link
                        v-if="row.item.status == 1"
                        :to="'/kirim-inven/retur/' + row.item.id"
                    >
                        <b-button
                            size="sm"
                            variant="success"
                            v-b-tooltip.hover.top
                            title="Lanjut Draft"
                        >
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                    </router-link>
                    <router-link
                        v-if="row.item.status == 2"
                        :to="'/kirim-inven/retur/' + row.item.id"
                    >
                        <b-button
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Detail Retur Kirim Inven"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            calculateTotalData: {},

            filter: {
                no_faktur: "",
                status: -1
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                {
                    key: "no_faktur",
                    label: "No. Faktur Rektur",
                    sortable: true
                },
                { key: "detail", label: "Detail", sortable: false },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 0, text: "DRAFT" },
                { value: 1, text: "PENDING" },
                { value: 2, text: "APPROVED" }
            ]
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();

            Promise.all([getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(error => {
                    this.initStatus = -1;
                    error;
                });
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
                true
            );

            if (!this.$helper.isBlank(this.filter.no_faktur)) {
                param += "&no_faktur=" + this.filter.no_faktur;
            }

            if (this.filter.status != -1) {
                param += "&status=" + this.filter.status;
            }

            if (this.sortBy != null) {
                param +=
                    "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("return-inventory-pgi" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        createReturKirimInvent() {

            this.isSubmitting = true;

            this.$axios
                .post("return-inventory-pgi/draft")
                .then(res => {
                    let data = res.data.data;
                    this.$router.push({
                        name: "Draft Retur Kirim Invent",
                        params: { id: data.sendback_id }
                    });
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        getStatusBadge(status) {
            switch (status) {
                case 0:
                    return ["dark", "DRAFT"];
                case 1:
                    return ["warning", "PENDING"];
                case 2:
                    return ["success", "APPROVED"];
                default:
                    return ["light", "-"];
            }
        },

        parseDate(date) {
            if (!date) return "-";

            return `${this.$helper.parseDate(
                date
            )}, ${this.$helper.parseHourMinute(date)}`;
        }
    },

    created() {
        this.init();
        this.$helper.toastFlash(this);
    }
};
</script>
